import React, { memo, useState } from 'react';
import InfoIcon16 from '../../../../../resources/images/info16.svg';
import InfoIcon24 from '../../../../../resources/images/info_24.svg';
import Button from '../../../../global/atoms/button';
import GlobalModal from '../../../../global/atoms/globalModal/GlobalModal';
import { getAEMCashFlowAlterableData } from '../../utils/cashflowUtils';
import { AccountInfoTestId } from '../../../GRTestId';
import { useAnalyticsContext } from '../../../../../config/GoogleTagManagerEvents';
import { EVENT_ECOMMERCE_NAMES_CONFIG } from '../../../../../constants/analyticsConstants/Ecommerce';
import './LicenseModal.scss';

const LicenseModal = () => {
    const [isDriverLicense, setIsDriverLicense] = useState(false);
    const { accountScreenConfig = {} } = getAEMCashFlowAlterableData() || {};
    const { driversLicenseInfoTitle = '', driversLicenseInfoDescription = '' } = accountScreenConfig || {};
    const { sendEventsForGRModalOpened, sendEventsForModalClosed } = useAnalyticsContext();

    const handleDriverLicenseModal = () => {
        setIsDriverLicense(!isDriverLicense);
        if (!isDriverLicense) {
            sendEventsForGRModalOpened(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_FORM_VIEWED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_MODAL_DRIVER_LICENSE,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_INFORMATION,
                ''
            );
        } else {
            sendEventsForModalClosed(
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CTA_CLICKED,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_CLOSE,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_BUTTON,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CCA_MODAL,
                EVENT_ECOMMERCE_NAMES_CONFIG.ECOMMERCE_CLOSE
            );
        }
    };

    const driverLicenseTitle = () => {
        return (
            <>
                <InfoIcon24 tabIndex={'-1'} aria-hidden={true} />
                <span>{driversLicenseInfoTitle}</span>
            </>
        );
    };

    const driverLicenseContent = () => {
        return (
            <>
                <div
                    tabIndex={'0'}
                    className="driver-license__contents"
                    dangerouslySetInnerHTML={{ __html: driversLicenseInfoDescription }}></div>
            </>
        );
    };

    return (
        <>
            <Button
                type="button"
                className="driver-license__btn"
                onClick={handleDriverLicenseModal}
                buttonAriaLabel="Driver License Info"
                dataTestid={AccountInfoTestId.LICENSE_MODAL.BUTTON}>
                <InfoIcon16 aria-hidden="true" tabIndex={'-1'} />
            </Button>

            <GlobalModal
                titleClasses={'driver-license_title'}
                className={'width-327'}
                isOpen={isDriverLicense}
                onRequestClose={handleDriverLicenseModal}
                title={driverLicenseTitle()}
                content={driverLicenseContent()}
                handleClose={handleDriverLicenseModal}
            />
        </>
    );
};

export default memo(LicenseModal);
